import { Component, FileText } from "lucide-react";

import {
  SidebarNavItem,
  SidebarSection,
} from "components/sidebar/sections/SidebarNav";

const UiSandboxSidebar = () => (
  <>
    <SidebarSection label="Primitives" icon={<Component />}>
      <SidebarNavItem to="/ui-sandbox/components">Components</SidebarNavItem>
    </SidebarSection>

    <SidebarSection label="Forms" icon={<FileText />}>
      <SidebarNavItem to="/ui-sandbox/forms/contact">
        Contact Form
      </SidebarNavItem>
      <SidebarNavItem to="/ui-sandbox/forms/campaign">
        Campaign Form
      </SidebarNavItem>
      <SidebarNavItem to="/ui-sandbox/forms/contact-email">
        Contact Email Form
      </SidebarNavItem>
    </SidebarSection>
  </>
);

export default UiSandboxSidebar;
